import { render } from "./loading.vue?vue&type=template&id=0b0f029b&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=0b0f029b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b0f029b"

export default script